<template>
	<vue3-confirm-dialog/>
	<!-- ----------------------------------------- -->
	<!-- <main> -->
		<router-view v-slot="{ Component }">
			<!-- <transition name="fade" mode="out-in">
				<keep-alive>
					<div :key="$route.name" id="app"> -->
						<component :key="$route.path" :is="Component"/>
					<!-- </div>
				</keep-alive>
			</transition> -->
		</router-view>		
	<!-- <LoginPage/> -->
	<!-- </main> -->
	<!-- ----------------------------------------- -->
</template>
<!-- ======================================================= -->
<script>
export default {
  name: 'App',
}
</script>
<!-- ======================================================= -->
<style>
:root{
	--c-white: #FFFFFF;
	--c-primary: #0d59a5;
}
html,
body,
#app {
	width: 100% !important;
	height: 100% !important;
	margin: 0;
	padding: 0;
	background-color: white;
	color: black;
	font-size: 12pt;
}
* {
	/* user-drag: none; */
	-webkit-user-drag: none !important;
	-moz-window-dragging: none !important;
	user-select: none !important;
	-webkit-user-select: none !important;
	-moz-user-select: none !important;
}
.container{
    max-width: 100% !important;
}
.btn-roadfly{
  color: white !important;
  background-color: var(--c-primary) !important;
  position: relative;
}
.btn-roadfly:hover, .btn-roadfly:focus, .btn-roadfly:active, .btn-roadfly.show{
    background-color: #2c4ba1 !important;
    color: white !important;
}
.btn .spinner-border{
  width: 28px !important;
  height: 28px !important;
  position: absolute !important;
  top: 5px;
  left: 5px;
}
.btn{
    position: relative;
}
#box{
    float: right;
    width: 80%;
    padding: 15px;
    height: calc(100% - 30px);
}


.fs-12pt, .fs-12pt *{ font-size: 12pt !important;}
.fs-11pt, .fs-11pt *{ font-size: 11pt !important; font-weight: normal !important;}
.fs-10pt, .fs-10pt *{ font-size: 10pt !important; font-weight: normal !important;}
.fs-9pt, .fs-9pt *{ font-size: 9pt !important; font-weight: normal !important;}
.w-5{ width: 5% !important; min-width: 5% !important; max-width: 5% !important; }
.w-7{ width: 7% !important; min-width: 7% !important; max-width: 7% !important; }
.w-8{ width: 8% !important; min-width: 8% !important; max-width: 8% !important; }
.w-10{ width: 10% !important; min-width: 10% !important; max-width: 10% !important; }
.w-12{ width: 12% !important; min-width: 12% !important; max-width: 12% !important; }
.w-15{ width: 15% !important; min-width: 15% !important; max-width: 15% !important; }
.w-18{ width: 18% !important; min-width: 18% !important; max-width: 18% !important; }
.w-20{ width: 20% !important; min-width: 20% !important; max-width: 20% !important; }
.w-25{ width: 25% !important; min-width: 25% !important; max-width: 25% !important; }
.w-30{ width: 30% !important; min-width: 30% !important; max-width: 30% !important;}
.w-35{ width: 35% !important; min-width: 35% !important; max-width: 35% !important; }
.w-40{ width: 40% !important; min-width: 40% !important; max-width: 40% !important; }
.w-45{ width: 45% !important; min-width: 45% !important; max-width: 45% !important; }
.w-50{ width: 50% !important; min-width: 50% !important; max-width: 50% !important; }
.w-55{ width: 55% !important; min-width: 55% !important; max-width: 55% !important; }
.w-60{ width: 60% !important; min-width: 60% !important; max-width: 60% !important; }
.w-65{ width: 65% !important; min-width: 65% !important; max-width: 65% !important; }
.w-70{ width: 70% !important; min-width: 70% !important; max-width: 70% !important; }
.w-80{ width: 80% !important; min-width: 80% !important; max-width: 80% !important; }
.w-100{ width: 100% !important; max-width: 100% !important; }
.w-50px{ width: 50px !important; min-width: 50px !important; max-width: 50px !important; }
.w-100px{ width: 100px !important; min-width: 100px !important; max-width: 100px !important; }

table{
    width: 100%;
}
.table-fixed thead > tr, .table-fixed tbody > tr {
    display: flex;
    justify-content: space-around;
    flex: 0 0 auto;
}
.table-fixed th, .table-fixed td{
    flex: 1;
}
.table-fixed tbody {
    overflow: scroll;
    display: flex;
    flex-direction: column;
}




.dropstart .dropdown-item{
	font-size: 14pt;
}
.dropstart .dropdown-item::before{
	font-size: 18pt;
	margin-right: 10px;
}
.dropdown-item{
	cursor: pointer;
}
.table tbody *{
    user-select: text !important;
    -webkit-user-select: text !important; /* Safari fallback only */
    -webkit-user-select: text !important; /* Chrome/Safari */
    -moz-user-select: text !important; /* Firefox */
    -ms-user-select: text !important; /* IE10+ */
}
.select, select *, select td, select a, select tbody *{
    user-select: text !important;
    -webkit-user-select: text !important; /* Safari fallback only */
    -webkit-user-select: text !important; /* Chrome/Safari */
    -moz-user-select: text !important; /* Firefox */
    -ms-user-select: text !important; /* IE10+ */
}

.unselect, .unselect *, .unselect td, .unselect a, .unselect tbody *{
	-webkit-user-drag: none !important;
	-moz-window-dragging: none !important;
	user-select: none !important;
	-webkit-user-select: none !important;
	-moz-user-select: none !important;
}

.loadingSpinner{
    z-index: 999999;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
}
.loadingSpinner .spinner-border{
	position: absolute;
	width: 50px;
	height: 50px;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    color: var(--c-primary);
	border-width: 5pt !important;
}
textarea{
    resize: none !important;
}
.subtitle{
    display: block;
    font-size: 10pt;
    color: black;
}
.fw-bold, .fw-bold *{
    font-weight: bold !important;
}
.input-group .select2-selection{
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.left-radius-zero .select2-selection{
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.radius-zero .select2-selection{
    border-radius: 0 !important;
}
.rtl{
    direction: rtl !important;
}
.ltr{
    direction: ltr !important;
}



.multiselect__tag, .multiselect__option--selected{
    background-color: var(--c-primary) !important;
    color: white !important;
}
.multiselect__tag .multiselect__tag-icon::after{
    color: white !important;
    fill: white !important;
}
.input-group .multiselect__tags{
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
</style>
